import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'

import AttachedFilesBox from '../Shared/AttachedFilesBox'
import ModalAddFile from '../Shared/ModalAddFile'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'
import ModalAddServicio from './ModalAddServicio'

import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'
import Comentarios from '../Shared/Comentarios'

import { isAllowedToViewComponent, formatcoin, getDivisa } from '../../utils/helpers';

import {
    getSolicitud,
    updateInputs,
    addFile,
    removeFiles,
    seleccionarProveedor,
    displayModalAddServicio,
    removeSolicitudServicioItems,
    seleccionarMoneda,
    enviarComentario,
    editarComentario,
    eliminarComentario
} from '../../actions/solicitudservicioot'


import {
    showModalSelector,
    selectFromSelector
} from '../../actions/common'



class General extends Component {


    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1', payload)

            const estado = this.props.solicitudservicioot.get('estado')

            if (estado == 1) {
                this.props.updateInputs('addModificacion', true)
            }
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/auxiliares', fn)
    }



    handleOpenSelectorProveedor = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'identificacion', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'nombre', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.seleccionarProveedor(payload));
        }
        this.props.showModalSelector('Listado de proveedores', columns, '/proveedores', fn)
    }

    modificarSolicitud = (path, value, id) => {
        this.props.updateInputs(path, value, id)
        this.props.updateInputs('addModificacion', true)
    }

    handleOpenSelectorMoneda = (moneda) => {
        this.props.seleccionarMoneda(moneda)
    }


	render() {

        const { id, solicitudservicioot, enums, user, divisas } = this.props

        if (!id) return null

        const moneda = solicitudservicioot.getIn(['cotizaciones',0,'moneda'])
        const divisa = getDivisa(divisas, moneda)

        const esResponsableCompras = solicitudservicioot.getIn(['responsable_compras', 'id']) == user.get('id')
        const esSuperusuario = user.get('es_superusuario')
        const estado = solicitudservicioot.get('estado')
        const readOnly = (!esResponsableCompras && !esSuperusuario) || ((estado===0) || (estado >= 3 ))
        //const readOnly = true



        const totalSevicios_sin_iva = solicitudservicioot.get('servicios').reduce((a, b) => {
            a += b.get('valor')
            return a
        }, 0)


        const totalSevicios = solicitudservicioot.get('servicios').reduce((a, b) => {
            a += Number(b.get('valor_con_iva'))
            return a
        }, 0)

        let nombre = ''
        const documento = solicitudservicioot.get('documentos').first()
        if (documento) {
            const consecutivo = documento.get('consecutivo') ? documento.get('consecutivo') : null
            if (consecutivo) {
                nombre = `${enums.documentos.tipos[documento.get('tipo')].PREFIJO}${consecutivo}`
            }
        }

        const actionsSectionDetallesServicios = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" onClick={ e => this.props.displayModalAddServicio(true, 'Agregar Item', 'create') } title="Adicionar servicio" disabled={readOnly} />,
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={ e => this.props.removeSolicitudServicioItems() } title="Eliminar servicio" danger disabled={ solicitudservicioot.get('servicios').filter(x => x.get('selected')).count() === 0 }/>
        ]

        const disabled_comment = (estado === 0 || estado === 7);

		return (
            <div>
                <BoxSection title="Información básica">

                    <div className="row">
                        {
                            isAllowedToViewComponent('administrador', solicitudservicioot.get('solicitante')) && solicitudservicioot.get('tipo') != 5 && solicitudservicioot.get('estado') != 0 && solicitudservicioot.get('estado') != 7 ? (

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Solicitante</label>
                                        <SelectorInput value={ solicitudservicioot.getIn(['solicitante', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.solicitante`) } onReset={ () => this.props.updateInputs(`solicitud.solicitante`, null) } />
                                    </div>
                                </div>

                            ):(
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Solicitante</label>
                                        <input type="text" value={ solicitudservicioot.getIn(['solicitante', 'fullname']) || '' } className="form-control input-sm" disabled/>
                                    </div>
                                </div>
                            )
                        }

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>
                                <input type="text" value={ solicitudservicioot.getIn(['solicitante', 'email']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>



                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input type="text" value={ solicitudservicioot.getIn(['solicitante', 'extension']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Área</label>
                                <input type="text" value={ solicitudservicioot.getIn(['solicitante', 'area', 'nombre']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        {
                            solicitudservicioot.get('documento_origen_id') && <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">Orden/Contrato</label>
                                    <input type="text" value={enums.documentos.tipos[solicitudservicioot.getIn(['documento_origen', 'tipo'])].PREFIJO + solicitudservicioot.getIn(['documento_origen', 'consecutivo']) || ''} className="form-control input-sm" disabled />
                                </div>
                            </div>
                        }

                    </div>


                    <div className="row">

                        {
                            isAllowedToViewComponent('administrador', solicitudservicioot.get('responsable_compras')) && solicitudservicioot.get('tipo') != 5 && solicitudservicioot.get('estado') != 0 && solicitudservicioot.get('estado') != 7 ? (

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Responsable de compras</label>
                                        <SelectorInput value={ solicitudservicioot.getIn(['responsable_compras', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.responsable_compras`) } onReset={ () => this.props.updateInputs(`solicitud.responsable_compras`, null) } />
                                    </div>
                                </div>

                            ):(
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Responsable de compras</label>
                                        <input className="form-control input-sm" type="text" value={ solicitudservicioot.getIn(['responsable_compras', 'fullname']) || '' } disabled/>
                                    </div>
                                </div>
                            )
                        }


                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>
                                <input className="form-control input-sm" value={ solicitudservicioot.getIn(['responsable_compras', 'email']) || '' } disabled />
                            </div>
                        </div>

                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input className="form-control input-sm" type="text" value={ solicitudservicioot.getIn(['responsable_compras', 'extension']) || '' }  disabled/>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Fecha de solicitud</label>
                                <input className="form-control input-sm" value={ moment(solicitudservicioot.get('created_at')).format('DD/MM/YYYY')  || ''  } disabled />
                            </div>
                        </div>


                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">No. Solicitud</label>
                                <input className="form-control input-sm" value={ solicitudservicioot.get('id') || '' } disabled />
                            </div>
                        </div>

                    </div>


                </BoxSection>

                <div className="separator"></div>

                <BoxSection title="Información del servicio">

                    <div className="row">



                        <div className="col-md-7">
                            <div className="form-group">
                                <label className="control-label">Proyecto/Evento/Actividad</label>
                                <input type="text" value={ solicitudservicioot.get('proyecto_evento') || '' } className="form-control input-sm" onChange={ (e) => this.modificarSolicitud('solicitud.proyecto_evento', e.target.value, id) } disabled = { readOnly } />
                            </div>
                        </div>


                        {
                            readOnly ? (
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label className="control-label">Proveedor</label>
                                        <input type="text" className="form-control input-sm" value={ solicitudservicioot.getIn(['cotizaciones', '0', 'proveedore', 'nombre']) || '' } disabled />
                                    </div>
                                </div>

                            ):(
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label className="control-label">Proveedor</label>
                                        <SelectorInput value={ solicitudservicioot.getIn(['cotizaciones', '0', 'proveedore', 'nombre']) || '' } onClick={ () => this.handleOpenSelectorProveedor('solicitud.cotizaciones.0.proveedore') } onReset={ () => null } />
                                    </div>
                                </div>
                            )
                        }

                        {
                            readOnly ? (

                            <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">Fecha de entrega</label>
                                    <input type="text" className="form-control input-sm" value={ moment(solicitudservicioot.get('fecha_requerido')).format('DD/MM/YYYY') } disabled/>
                                </div>
                            </div>


                            ):(


                            <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">Fecha de entrega</label>
                                    <input type="date" className="form-control input-sm" value={ moment(solicitudservicioot.get('fecha_requerido')).format('YYYY-MM-DD') } onChange={ (e) => this.modificarSolicitud('solicitud.fecha_requerido', e.target.value, id) } disabled = { readOnly }/>
                                </div>
                            </div>

                            )
                        }



                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Box title={ `Responsables del ingreso del proveedor` } onModal>
                                <div className="box-content" style={{ maxHeight: '81px', overflowX: 'hidden' }}>
                                    <table className="table table-condensed">
                                        <tbody>
                                            {
                                                solicitudservicioot.get('responsables_ingreso').map((a, b) => {
                                                    return (
                                                        <tr key={ `tr3[${a.get('id')}]` } className={ a.get('selected') ? 'info-dark' : '' }>
                                                            <td style={{ width: '43%' }}><input type="text" className="form-control input-sm" value={ a.getIn(['usuario', 'fullname']) ? a.getIn(['usuario', 'fullname']) : '' } disabled /></td>
                                                            <td style={{ width: '43%' }}><input type="text" className="form-control input-sm" value={ a.getIn(['usuario', 'area', 'nombre']) || '' } disabled /></td>
                                                            <td style={{ width: '14%' }}><input type="text" className="form-control input-sm" value={ a.getIn(['usuario', 'extension']) || '' } disabled /></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                        <div className="col-md-6">
                            <Box title={ `Responsables del recibo del servicio` } onModal>
                                <div className="box-content" style={{ maxHeight: '81px', overflowX: 'hidden' }}>
                                    <table className="table table-condensed">
                                        <tbody>
                                            {
                                                solicitudservicioot.get('responsables_recibo').map((a, b) => {
                                                    return (
                                                        <tr key={ `tr3[${a.get('id')}]` } className={ a.get('selected') ? 'info-dark' : '' }>
                                                            <td style={{ width: '43%' }}><input type="text" className="form-control input-sm" value={ a.getIn(['usuario', 'fullname']) ? a.getIn(['usuario', 'fullname']) : '' } disabled /></td>
                                                            <td style={{ width: '43%' }}><input type="text" className="form-control input-sm" value={ a.getIn(['usuario', 'area', 'nombre']) || '' } disabled /></td>
                                                            <td style={{ width: '14%' }}><input type="text" className="form-control input-sm" value={ a.getIn(['usuario', 'extension']) || '' } disabled /></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                    </div>
                </BoxSection>

                <div className="separator"></div>

                <BoxSection title="Detalles servicios" actions={ actionsSectionDetallesServicios }>
                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-divisas">
                        <tbody>
                        <tr>
                                <th style={{ maxWidth: '86%', padding:'0 10px' }}>Tipo de moneda:</th>
                                <th style={{textAlign:'right'}}>
                                <div style ={{alignItems:'flex-end'}}  className="btn-group" role="group">
                                    {
                                        divisas && divisas.map((d,i) => {
                                            return (
                                                <button key={`d[${i}]`} style={{borderRadius: '5px'}} onClick={ !readOnly ? () => this.handleOpenSelectorMoneda(d.get('CODIGO')) : null }  type="button" className={ divisa.moneda == d.get('CODIGO') ? 'btn btn-primary' : 'btn btn-outline-primary' } >{ d.get('CODIGO') }</button>
                                            );
                                        })
                                    }
                                </div>
                            </th>
                        </tr>
                        </tbody>
                    </table>
                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                        <thead>
                            <tr>
                                <th width="20px"></th>
                                <th style={{ width: '5%' }}>No.</th>
                                <th style={{ width: '40%' }}>Descripción del servicio</th>
                                <th style={{ width: '18%' }}>Valor del servicio sin IVA</th>
                                <th style={{ width: '18%' }}>Valor total del servicio</th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                (solicitudservicioot.get('servicios').count() > 0) ?
                                    solicitudservicioot.get('servicios').map((x, n) => {
                                        return (
                                            <tr key={ x.get('id') } className={ x.get('selected') ? 'info' : '' } >
                                                <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') } onChange={ (e) => this.props.updateInputs(`solicitud.servicios.${n}.selected`, e.target.checked) } disabled={ n == 0 || solicitudservicioot.get('estado') != 3 } /></td>
                                                <td className={ `${ readOnly ? '' : 'LinkToEdit' }`} style={{ textAlign: 'right' }} onClick={ () => readOnly ? null : this.props.displayModalAddServicio(true, 'Modificación de items', 'edit', n) }>{ n + 1 }</td>
                                                <td>{ x.get('descripcion') }</td>
                                                <td style={{ textAlign: 'right' }}>{formatcoin(x.get('valor'),divisa.simbolo)}</td>
                                                <td style={{ textAlign: 'right' }}>{formatcoin(x.get('valor_con_iva'),divisa.simbolo)}</td>
                                            </tr>
                                        )
                                    })
                                :
                                    <tr>
                                        <td colSpan={ 4 } style={{ textAlign: 'center' }}>Para crear los servicios haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                                    </tr>
                            }
                        </tbody>
                    </table>

                </BoxSection>

                <div className="separator"></div>

                <BoxSection title="Recursos">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="control-label">Ordenador del gasto</label>
                                        <input type="text" className="form-control input-sm" value={ solicitudservicioot.getIn(['servicios', '0', 'cencos', '0', 'usuario', 'fullname']) || '' } disabled />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Anticipo aprobado, %</label>
                                        <input type="number" className="form-control input-sm" value={ solicitudservicioot.getIn(['cotizaciones', '0', 'anticipo']) } disabled />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Valor del anticipo</label>
                                        <input type="text" className="form-control input-sm" value={formatcoin(((Number(solicitudservicioot.getIn(['cotizaciones', '0', 'anticipo'])) / 100) * totalSevicios_sin_iva),divisa.simbolo)} disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <Box title="Distribución en centros de costo" onModal>
                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                    <table className="table table-condensed">
                                        <tbody>
                                            {
                                                solicitudservicioot.getIn(['servicios', '0', 'cencos']).map((x, n) => {
                                                    return (
                                                        <tr key={ `tr[${x.get('id')}]` }>
                                                            <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                                            <td style={{ width: '55%' }} ><input type="text" className="form-control input-sm" value={ x.get('descripcion') ? x.get('descripcion') : '' } disabled /></td>
                                                            <td><input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.getIn(['pivot', 'porcentaje']) } disabled /></td>
                                                            <td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
                                                            <td><input type="text" className="form-control input-sm" value={formatcoin((Number(x.getIn(['pivot', 'porcentaje'])) / 100 * totalSevicios),divisa.simbolo)} disabled /></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                    </div>
                </BoxSection>
                <div className="separator"></div>

                <BoxSection title="Observaciones">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <textarea type="text" className="form-control input-sm" rows={4} value={ solicitudservicioot.get('observaciones') || '' } disabled />
                            </div>
                        </div>
                    </div>
                </BoxSection>

                <div className="separator"></div>

                <Comentarios
                    foros = { solicitudservicioot.get('foros') }
                    comentario = { this.props.comentario }
                    updateInputs = { this.props.updateInputs }
                    disabled_comment = { disabled_comment }
                    enviarComentario = { this.props.enviarComentario }
                    editarComentario = { this.props.editarComentario }
                    eliminarComentario = { this.props.eliminarComentario }
                />

                <div className="separator"></div>

                <AttachedFilesBox
                    files={ solicitudservicioot.get('adjuntos').filter(adjunto => !adjunto.get('documento_id')) }
                    root='solicitud'
                    removeFiles = { this.props.removeFiles }
                    updateInputs = { this.props.updateInputs }
                    obj={ solicitudservicioot }
                    check={ 'solicitud' }
                />

                <ModalAddFile
                    action={ () => this.props.addFile(`/files/${id}`, [() => this.props.getSolicitud(id)]) }
                />


                <ModalSelectorFromList />

                <ModalAddServicio />


            </div>
		)
	}
}




function mapStateToProps(state) {
    return {
        id: state.solicitudservicioot.get('id'),
        solicitudservicioot: state.solicitudservicioot.get('solicitud'),
        enums: state.common.get('enums').toJS(),
        user: state.common.get('user'),
        divisas: state.common.getIn(['parametros', 'DIVISAS']),
        comentario: state.solicitudservicioot.get('comentario')
    }
}



function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)),
        addFile: (url, actions) => dispatch(addFile(url, actions)),
        removeFiles: () => dispatch(removeFiles()),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        seleccionarProveedor: (payload) => dispatch(seleccionarProveedor(payload)),
        displayModalAddServicio: (show, title, mode, index) => dispatch(displayModalAddServicio(show, title, mode, index)),
        removeSolicitudServicioItems: () => dispatch(removeSolicitudServicioItems()),
        seleccionarMoneda: (moneda) => dispatch(seleccionarMoneda(moneda)),
        enviarComentario: () => dispatch(enviarComentario()),
        editarComentario: (id) => dispatch(editarComentario(id)),
        eliminarComentario: (id) => dispatch(eliminarComentario(id))
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(General)



// WEBPACK FOOTER //
// ./src/components/SolicitudServicioOT/General.jsx